import { AxiosError } from "axios";
import { isBaseError, toBaseError } from "../../../../common/utils/base_error";
import { axiosInstance } from "../../../../api/axiosInstance";
import { IEstoqueService } from "./estoque_service";
import { GetAllEstoqueEntradaRequest, GetAllEstoqueEntradaResponse } from "../daos/read/get_all_estoque";
import { handleAxiosResponse } from "../../../../common/utils/axios_response";
import { DeleteEntradaPRequest, DeleteEntradaPResponse } from "../daos/delete/delete_entrada_produto";
import { UpdateEntradaPRequest, UpdateEntradaPResponse } from "../daos/update/update_entrada_produto";
import { CreateEntradaPRequest, CreateEntradaPResponse } from "../daos/create/create_entrada_produto";
import { CreateEntradaMultiPRequest, CreateEntradaMultiPResponse } from "../daos/create/create_entrada_multi_produto";
import { UpdateEntradaMultiPRequest, UpdateEntradaMultiPResponse } from "../daos/update/update_entrada_produto_multi";
import { GetAllEstoqueSaidaRequest, GetAllEstoqueSaidaResponse } from "../daos/read/get_all_saida_produtos";
import { CreateSaidaPRequest, CreateSaidaPResponse } from "../daos/create/create_saida_produto";
import { UpdateSaidaPRequest, UpdateSaidaPResponse } from "../daos/update/update_saida_produto";
import { DeleteSaidaPRequest, DeleteSaidaPResponse } from "../daos/delete/delete_saida_produto";
import { UpdateSaidaMultiPRequest, UpdateSaidaMultiPResponse } from "../daos/update/update_saida_multi_produto";
import { CreateSaidaMultiPRequest, CreateSaidaMultiPResponse } from "../daos/create/create_saida_multi_produto";
import { GetAllEstoqueControleRequest, GetAllEstoqueControleResponse } from "../daos/read/get_all_controle_estoque_produtos";
import { DeleteControleEstoqueRequest, DeleteControleEstoqueResponse } from "../daos/delete/delete_controle_estoque_produt";
import { CreateControleRequest, CreateControleResponse } from "../daos/create/create_controle_produto";
import { UpdateControleRequest, UpdateControleResponse } from "../daos/update/update_controle";
import { GetAllItemControleRequest, GetAllItemControleResponse } from "../daos/read/get_all_item_controle_estoque";
import { CreateItemControleRequest, CreateItemControleResponse } from "../daos/create/create_item_controle";
import { UpdateItemControleRequest, UpdateItemControleResponse } from "../daos/update/update_item_controle_multil";
import { DeleteItemControleRequest, DeleteItemControleResponse } from "../daos/delete/delete_item_controle";


export class EstoqueService implements IEstoqueService {

  //#region  Entrada Produtos
  async getAllListagemEstoque(request: GetAllEstoqueEntradaRequest): Promise<GetAllEstoqueEntradaResponse> {
    try {
      const result = await axiosInstance({}).post(`ControleEstoque/EntradaProduto/listEntradaProduto`, request);
      const response = handleAxiosResponse<GetAllEstoqueEntradaResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createEntradaP(request: CreateEntradaPRequest): Promise<CreateEntradaPResponse> {
    try {
      const result = await axiosInstance({}).post(`/ControleEstoque/EntradaProduto/create`, request);
      const response = handleAxiosResponse<CreateEntradaPResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async createEntradaMultiP(request: CreateEntradaMultiPRequest): Promise<CreateEntradaMultiPResponse> {
    try {
      const result = await axiosInstance({}).post(`/ControleEstoque/EntradaProduto/createMulti`, request);
      const response = handleAxiosResponse<CreateEntradaMultiPResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async updateEntradaP(request: UpdateEntradaPRequest): Promise<UpdateEntradaPResponse> {
    try {
      const result = await axiosInstance({}).post(`/ControleEstoque/EntradaProduto/update`, request);
      const response = handleAxiosResponse<UpdateEntradaPResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async updateEntradaMultiP(request: UpdateEntradaMultiPRequest): Promise<UpdateEntradaMultiPResponse> {
    try {
      const result = await axiosInstance({}).post(`/ControleEstoque/EntradaProduto/updateMulti`, request);
      const response = handleAxiosResponse<UpdateEntradaMultiPResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async deleteEntradaP(request: DeleteEntradaPRequest): Promise<DeleteEntradaPResponse> {
    try {
      const result = await axiosInstance({}).delete("/ControleEstoque/EntradaProduto/delete", { data: request });
      const response = handleAxiosResponse<DeleteEntradaPResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion
  //#region  Saida Produtos
  async getAllListagemSaida(request: GetAllEstoqueSaidaRequest): Promise<GetAllEstoqueSaidaResponse> {
    try {
      const result = await axiosInstance({}).post(`ControleEstoque/SaidaProduto/listSaidaProduto`, request);
      const response = handleAxiosResponse<GetAllEstoqueSaidaResponse>(result);

      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createSaidaP(request: CreateSaidaPRequest): Promise<CreateSaidaPResponse> {
    try {
      const result = await axiosInstance({}).post(`/ControleEstoque/SaidaProduto/create`, request);
      const response = handleAxiosResponse<CreateSaidaPResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async createSaidaMultiP(request: CreateSaidaMultiPRequest): Promise<CreateSaidaMultiPResponse> {
    try {
      const result = await axiosInstance({}).post(`/ControleEstoque/SaidaProduto/createMulti`, request);
      const response = handleAxiosResponse<CreateSaidaMultiPResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async updateSaidaP(request: UpdateSaidaPRequest): Promise<UpdateSaidaPResponse> {
    try {
      const result = await axiosInstance({}).post(`/ControleEstoque/SaidaProduto/update`, request);
      const response = handleAxiosResponse<UpdateSaidaPResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async updateSaidaMultiP(request: UpdateSaidaMultiPRequest): Promise<UpdateSaidaMultiPResponse> {
    try {
      const result = await axiosInstance({}).post(`/ControleEstoque/SaidaProduto/updateMulti`, request);
      const response = handleAxiosResponse<UpdateSaidaMultiPResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteSaidaP(request: DeleteSaidaPRequest): Promise<DeleteSaidaPResponse> {
    try {
      const result = await axiosInstance({}).delete("/ControleEstoque/SaidaProduto/delete", { data: request });
      const response = handleAxiosResponse<DeleteSaidaPResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

  //#region  ControleEstoque
  async getAllListagemControle(request: GetAllEstoqueControleRequest): Promise<GetAllEstoqueControleResponse> {
    try {
      const result = await axiosInstance({}).post(`ControleEstoque/ControleEstoque/listControleEstoque`, request);
      const response = handleAxiosResponse<GetAllEstoqueControleResponse>(result);

      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createControle(request: CreateControleRequest): Promise<CreateControleResponse> {
    try {
      const result = await axiosInstance({}).post(`/ControleEstoque/ControleEstoque/create`, request);
      const response = handleAxiosResponse<CreateControleResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateControle(request: UpdateControleRequest): Promise<UpdateControleResponse> {
    try {
      const result = await axiosInstance({}).post(`/ControleEstoque/ControleEstoque/update`, request);
      const response = handleAxiosResponse<UpdateControleResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteControleEstoque(request: DeleteControleEstoqueRequest): Promise<DeleteControleEstoqueResponse> {
    try {
      const result = await axiosInstance({}).delete("/ControleEstoque/ControleEstoque/delete", { data: request });
      const response = handleAxiosResponse<DeleteControleEstoqueResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

  //#region  ItemControleEstoque
  async getAllListagemItemControle(request: GetAllItemControleRequest): Promise<GetAllItemControleResponse> {
    try {
      const result = await axiosInstance({}).post(`ControleEstoque/ItemControle/listItemControle`, request);
      const response = handleAxiosResponse<GetAllItemControleResponse>(result);

      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async createItemControle(request: CreateItemControleRequest): Promise<CreateItemControleResponse> {
    try {
      const result = await axiosInstance({}).post(`/ControleEstoque/ItemControle/create`, request);
      const response = handleAxiosResponse<CreateItemControleResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async updateItemControle(request: UpdateItemControleRequest): Promise<UpdateItemControleResponse> {
    try {
      const result = await axiosInstance({}).post(`/ControleEstoque/ItemControle/update`, request);
      const response = handleAxiosResponse<UpdateItemControleResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteItemControle(request: DeleteItemControleRequest): Promise<DeleteItemControleResponse> {
    try {
      const result = await axiosInstance({}).delete("/ControleEstoque/ItemControle/delete", { data: request });
      const response = handleAxiosResponse<DeleteItemControleResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion
}
